<sb-support-text-block [title]="'Email' | translate" [body]="supportEmail()" />
<sb-support-text-block [title]="'Phone Number' | translate" [body]="supportPhone()" />
